import { render } from "./promotion-list-page.vue?vue&type=template&id=0ad45f7a&scoped=true"
import script from "./promotion-list-page.vue?vue&type=script&lang=js"
export * from "./promotion-list-page.vue?vue&type=script&lang=js"

import "./promotion-list-page.vue?vue&type=style&index=0&id=0ad45f7a&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad45f7a"]])

export default __exports__